let hasOutdatedToken = false

export const setHasOutdatedToken = (value: boolean) => {
  hasOutdatedToken = value
}

export const getHasOutdatedToken = () => hasOutdatedToken
